import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import './style.css';
import { useNavigate, useParams } from 'react-router-dom';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import InputMask from 'react-input-mask';

const CadastroTrabalhador = () => {
    const [cpf, setCpf] = useState('');
    const [nome, setNome] = useState('');
    const [celular, setCelular] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [rg, setRg] = useState('');
    const [sexo, setSexo] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [error, setError] = useState('');
    const { dbName } = useParams();
    const navigate = useNavigate();

    const validateEmail = (email: any) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const checkPasswordStrength = (password: any) => {
        if (password.length < 6) return "Fraca";
        if (password.match(/[a-z]/) && password.match(/[A-Z]/) && password.match(/[0-9]/) && password.length >= 8) {
            return "Forte";
        }
        return "Média";
    };

    const handleSubmit = async () => {
        if (!cpf || !nome || !celular || !dataNascimento || !rg || !sexo || !email || !senha || !confirmarSenha) {
            setError("Por favor, preencha todos os campos obrigatórios.");
            return;
        }

        if (senha !== confirmarSenha) {
            setError("As senhas não coincidem");
            return;
        }

        if (!validateEmail(email)) {
            setError("E-mail inválido");
            return;
        }

        try {
            const payload = {
                nome,
                celular: celular.replace(/\D/g, ''), // Remove caracteres não numéricos
                cpf: cpf.replace(/\D/g, ''),
                data_nascimento: dataNascimento,
                sexo,
                rg: rg.replace(/\D/g, ''), // Remove caracteres não numéricos
                email,
                senha,
                reaproveitamento: 1,
            };

            const response = await api.post('trabalhadores/cadastro', payload);

            if (response.status === 200) {
                setAlert({
                    show: true,
                    message: "Trabalhador cadastrado com sucesso! Você será redirecionado para a tela de login.",
                    variant: "success",
                });

                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            }
        } catch (error) {
            console.error(error);
            setError("Ocorreu um erro ao cadastrar o trabalhador. Tente novamente.");
        }
    };

    return (
        <div className="form-container">
            <h2 className="form-title">Bem-vindo! Cadastre-se aqui e reaproveite seus ASOs!</h2>
            <p className="login-link">
                Já possui uma conta?{' '}
                <span
                    onClick={() => navigate('/login')}
                    className="clickable-link"
                >
                    Clique aqui
                </span>{' '}
                para fazer login.
            </p>
            <div className="form-card-container">
                <Card className="form-card">
                    <div className="form-card-content">
                        <div className="form-field">
                            <label htmlFor="nome-input" className="form-label">Nome Completo</label>
                            <input
                                type="text"
                                id="nome-input"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="cpf-input" className="form-label">CPF</label>
                            <InputMask
                                mask="999.999.999-99"
                                value={cpf}
                                onChange={(e: any) => setCpf(e.target.value)}
                                className="form-input"
                                placeholder="Insira o CPF"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="celular-input" className="form-label">Celular</label>
                            <InputMask
                                mask="(99) 99999-9999"
                                value={celular}
                                onChange={(e: any) => setCelular(e.target.value)}
                                className="form-input"
                                placeholder="(XX) XXXXX-XXXX"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="data-nascimento-input" className="form-label">Data de Nascimento</label>
                            <input
                                type="date"
                                id="data-nascimento-input"
                                value={dataNascimento}
                                onChange={(e) => setDataNascimento(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="rg-input" className="form-label">RG</label>
                            <InputMask
                                mask="99.999.999-9"
                                value={rg}
                                onChange={(e: any) => setRg(e.target.value)}
                                className="form-input"
                                placeholder="Insira o RG"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="sexo-input" className="form-label">Sexo</label>
                            <select
                                id="sexo-input"
                                value={sexo}
                                onChange={(e) => setSexo(e.target.value)}
                                className="form-input"
                            >
                                <option value="">Selecione</option>
                                <option value="M">Masculino</option>
                                <option value="F">Feminino</option>
                            </select>
                        </div>

                        <div className="form-field">
                            <label htmlFor="email-input" className="form-label">E-mail</label>
                            <input
                                type="email"
                                id="email-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        <div className="form-field">
                            <label htmlFor="senha-input" className="form-label">Senha</label>
                            <input
                                type="password"
                                id="senha-input"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                className="form-input"
                            />
                            <small>Força da senha: {checkPasswordStrength(senha)}</small>
                        </div>

                        <div className="form-field">
                            <label htmlFor="confirmar-senha-input" className="form-label">Confirmar Senha</label>
                            <input
                                type="password"
                                id="confirmar-senha-input"
                                value={confirmarSenha}
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                className="form-input"
                            />
                        </div>
                    </div>
                </Card>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="primary"
                        className="submit-button"
                        onClick={handleSubmit}
                    >
                        Continuar
                    </Button>
                </div>
            </div>

            {error && (
                <div className="error-message">
                    <p>{error}</p>
                </div>
            )}

            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
};

export default CadastroTrabalhador;
